import { css } from 'styled-components';
import { theme, whenFocused, whenActive, whenHovered } from "../../theme";
import { transparentize, lighten } from 'polished';
export function ghostVariant() {
  return css(["", ";", "{", ";}", "{", ";}&[aria-expanded='true'],", "{", ";}", ""], baseStyles, whenHovered, function (p) {
    return !p.$sharedHoverEnabled && hoverStyles;
  }, whenFocused, focusStyles, whenActive, activeStyles, function (p) {
    return p.disabled && "\n      pointer-events: none;\n      background-color: transparent;\n      color: ".concat(theme.colors.palette.tintA30, ";\n    ");
  });
}

function baseStyles(p) {
  if (p.$color === 'primary') {
    return css(["background-color:transparent;color:", ";"], theme.colors.palette.brandPrimary);
  }

  if (p.$color === 'error') {
    return css(["background-color:transparent;color:", ";"], theme.colors.palette.alertError);
  }

  if (p.$color === 'neutral') {
    return css(["background-color:transparent;color:", ";"], theme.colors.palette.whiteA80);
  }

  return css(["background-color:transparent;color:", ";"], theme.colors.palette.tintA80);
}

function hoverStyles(p) {
  if (p.$color === 'primary') {
    return css(["color:", ";background-color:", ";"], lighten(0.06, theme.colors.palette.brandPrimary), transparentize(0.8, theme.colors.palette.brandPrimary));
  }

  if (p.$color === 'error') {
    return css(["color:", ";background-color:", ";"], lighten(0.06, theme.colors.palette.alertError), transparentize(0.8, theme.colors.palette.alertError));
  }

  if (p.$color === 'neutral') {
    return css(["color:", ";background-color:", ";"], theme.colors.palette.whiteA80, theme.colors.palette.whiteA15);
  }

  return css(["color:", ";background-color:", ";"], theme.colors.palette.tintA80, theme.colors.palette.tintA15);
}

function focusStyles(p) {
  return hoverStyles(p);
}

function activeStyles(p) {
  if (p.$color === 'primary') {
    return css(["color:", ";background-color:", ";"], lighten(0.03, theme.colors.palette.brandPrimary), transparentize(0.85, theme.colors.palette.brandPrimary));
  }

  if (p.$color === 'error') {
    return css(["color:", ";background-color:", ";"], lighten(0.03, theme.colors.palette.alertError), transparentize(0.85, theme.colors.palette.alertError));
  }

  if (p.$color === 'neutral') {
    return css(["color:", ";"], theme.colors.palette.whiteA70);
  }

  return css(["color:", ";"], theme.colors.palette.tintA70);
}